<div class="wrapper flex flex-col justify-between">
  <div class="heading-row flex justify-between items-center mb-[40px]">
    <div class="heading text-type-2 truncate" data-testid="mgvw-panel-title">
      {{ record?.uuid ? title : 'Create' }}
    </div>
    @if (record?.uuid) {
      <div class="more-menu-container">
        @if (downloading) {
          <mat-spinner
            color="primary"
            diameter="24"
            mode="indeterminate"
            strokeWidth="3"
            data-testid="mgvw-download-spinner"
            ></mat-spinner>
        } @else {
          <button
            mat-icon-button
            [matMenuTriggerFor]="mgvwMoreMenu"
            class="more-menu-button"
            data-testid="mgvw-detail-more-menu"
            [matTooltip]="'More actions'"
            matTooltipClass="project-name-tooltip"
            >
            <mat-icon>more_horiz</mat-icon>
          </button>
        }
      </div>
      <mat-menu #mgvwMoreMenu="matMenu">
        <button
          mat-menu-item
          data-testid="mgvw-download-pdf"
          (click)="viewPdf()"
          >
          <mat-icon>download</mat-icon>
          <span>Download PDF</span>
        </button>
      </mat-menu>
    }
  </div>

  <div class="details flex-1">
    @if (notConfigured) {
      <div class="empty-config text-type-8 mb-[30px]">
        The MGVW form is not configured for this organization.
      </div>
    }

    @if (record?.uuid) {
      <div class="row-details flex flex-col gap-[12px] mb-[40px]">
        <div class="label w-full uppercase">Status:</div>
        <div class="value w-full text-type-11">
          <div
            [ngClass]="[statusMap[statusKey].bgColor, statusMap[statusKey].textColor]"
            class="status-chip px-[14px] rounded-full"
            data-testid="mgvw-status-chip"
            >
            {{ statusMap[statusKey].label }}
          </div>
        </div>
        @if (record?.origin === 'aashtoware') {
          <div class="hint-text text-type-14">
            Entered in AASHTOWare{{ record?.values?.entered_date ? ' on ' + record.values.entered_date : '' }}. Read-only in SiteNotes.
          </div>
        } @else if (record?.status === 'submitted') {
          <div class="hint-text text-type-14">
            Submitted to AASHTOWare{{ submittedOn() ? ' on ' + submittedOn() : '' }}{{ record?.submitted_by_name ? ' by ' + record.submitted_by_name : '' }}. Read-only.
          </div>
        }
      </div>
    }

    @for (section of sections; track section.key) {
      <div class="group-accordion" [class.is-expanded]="isSectionExpanded(section.key)">
        <div
          (click)="toggleSection(section.key)"
          (keydown.enter)="toggleSection(section.key)"
          class="group-header flex justify-between items-center cursor-pointer"
          role="button"
          tabindex="0"
          >
          <div class="group-title text-type-3">{{ section.label }}</div>
          <mat-icon
            [svgIcon]="isSectionExpanded(section.key) ? 'chevron-up' : 'chevron-down'"
            class="chevron-icon"
            />
        </div>
        <div class="group-content">
          @for (field of section.fields; track trackByName(0, field)) {
            @if (isBoolean(field)) {
              <!-- Same toggle row as the bid-item settings panel; the form is
                   disabled on read-only records so the toggle shows the value
                   without accepting input. -->
              <div [formGroup]="form" class="toggle-row w-full mb-[30px]">
                <div class="label text-type-13 uppercase">{{ field.label || field.name }}</div>
                <mat-slide-toggle
                  [formControlName]="field.name"
                  [attr.data-testid]="'mgvw-toggle-' + field.name"
                  class="slide-toggle-btn"
                  color="primary"
                  ></mat-slide-toggle>
              </div>
            } @else if (readOnly || isDisplayOnly(field)) {
              <app-view-field
                [attr.data-testid]="'mgvw-value-' + field.name"
                [label]="field.label || field.name"
                [value]="displayValue(field)"
                class="w-full mb-[30px] adjust-label"
                />
            } @else if (hasPickList(field)) {
              <app-dropdown
                [parentFormGroup]="form"
                [controlName]="field.name"
                [options]="pickListOptions[field.name] || []"
                [enableSearch]="true"
                [enableClearSelection]="!isRequired(field)"
                [label]="field.label || field.name"
                class="w-full mb-[20px]"
                />
            } @else if (isDate(field)) {
              <app-date-picker
                [parentFormGroup]="form"
                [controlName]="field.name"
                [label]="field.label || field.name"
                class="w-full mb-[20px]"
                />
            } @else if (isNumber(field)) {
              <app-number-input
                [parentFormGroup]="form"
                [controlName]="field.name"
                [label]="field.label || field.name"
                [isDecimalAllowed]="true"
                [decimalPlaces]="3"
                [maxLength]="12"
                [max]="999999999"
                class="w-full mb-[20px]"
                />
            } @else {
              <app-text-input
                [parentFormGroup]="form"
                [controlName]="field.name"
                [label]="field.label || field.name"
                [maxLength]="500"
                class="w-full mb-[20px]"
                />
            }
          }
        </div>
      </div>
    }

    @if (errorMessage) {
      <div class="error-message text-type-11 mt-[20px]">{{ errorMessage }}</div>
    }
  </div>

  @if (!readOnly && sections.length) {
    <div class="action-section mb-[5px] flex flex-row gap-[20px] w-full">
      <app-secondary-button
        (handleClick)="save()"
        [isDisabled]="!form.dirty || saving || submitting"
        [isLoading]="saving"
        class="flex-1"
        data-testid="mgvw-save"
        >
        Save
      </app-secondary-button>
      <app-primary-button
        (handleClick)="submit()"
        [isDisabled]="(!form.dirty && !record?.uuid) || saving || submitting"
        [isLoading]="submitting"
        class="flex-1"
        data-testid="mgvw-submit"
        >
        Submit
      </app-primary-button>
    </div>
  }
</div>
